import { IconProps } from '@models/icons';

function CouponIcon({ size = 16, color }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.25 18.0824H9.25H3.75C3.19772 18.0824 2.75 17.6347 2.75 17.0824V12.0824V9.0824C2.75 8.53011 3.19772 8.0824 3.75 8.0824H5.75M5.75 8.0824H11.25H18.75C19.3023 8.0824 19.75 7.63468 19.75 7.0824M5.75 8.0824V4.8324C5.75 4.28011 6.19772 3.8324 6.75 3.8324H17.75C18.8546 3.8324 19.75 4.72783 19.75 5.8324V7.0824M19.75 7.0824V12.5824"
                stroke={color} strokeWidth="2"/>
            <path
                d="M16.25 14.11C16.9039 12.1802 19.4 11.687 20.6923 13.3024C22.3077 15.3217 20.2885 18.1484 16.25 20.1677"
                stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M16.25 14.1099C15.5961 12.1801 13.1 11.6869 11.8077 13.3023C10.1923 15.3216 12.2115 18.1484 16.25 20.1677"
                stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export default CouponIcon;
